import axios from './axios'
import Router from '../../router/index'
import avatar from '@/assets/loading.gif'
export default {
  canUpLoadFileList: ['pdf', 'msg', 'xlsx', 'docx', 'jpg', 'xls', '7z', 'pptx', 'txt', 'ppt', 'bmp', 'png', 'tif', 'jpeg', 'rar', 'zip'],
  excelUpLoadFileList: ['xlsx', 'xls', 'csv'],
  excelUpLoadFile: ['xlsx', 'xls'],
  videoUpLoadFileList: ['mp4'],
  audioUpLoadFileList: ['mp3'],
  imgUpLoadFileList: ['jpg', 'png', 'jpeg', 'bmp', 'gif'],
  PDFUpLoadFileList: ['pdf', 'ppt', 'pptx'],
  txtFileList: ['text', 'txt'],
  onlyPDFUpLoadFileList: ['pdf'],
  commonPageSize: 10,
  subscriberTypeList: [
    {
      id: 0,
      name: '全部'
    },
    {
      id: 1,
      name: '运行'
    },
    {
      id: 2,
      name: '停止'
    }
  ],
  dnloadTaskTypeList: [
    {
      id: 0,
      name: '全部'
    },
    {
      id: 1,
      name: '待处理'
    },
    {
      id: 2,
      name: '处理中'
    },
    {
      id: 3,
      name: '处理失败'
    },
    {
      id: 4,
      name: '已准备'
    },
    {
      id: 5,
      name: '已失效'
    },
    {
      id: 6,
      name: '已取消'
    }
  ],
  userTagStateStatusList: [
    {
      id: '',
      name: '全部状态'
    },
    {
      id: 'IsEffective',
      name: '有效'
    },
    {
      id: 'UnEffective',
      name: '无效'
    }
  ],
  userTagTypeList: [
    {
      id: '',
      name: '全部标签'
    },
    // {
    //   id: 'DynamicUserTag',
    //   name: '动态标签'
    // },
    {
      id: 'StaticUserTag',
      name: '静态标签'
    },
    {
      id: 'CustomUserTag',
      name: '自定义标签'
    }
  ],
  channelType: [
    {
      id: '',
      name: '全部类型'
    },
    {
      id: 'Minisite',
      name: '微网站渠道'
    },
    {
      id: 'Message',
      name: '微信公众号渠道'
    },
    {
      id: 'ThirdPartyChannel',
      name: '第三方应用渠道'
    }
  ],
  returnHour (time, type) {
    if (!time || time < 0) {
      return '00'
    }
    if (type === 1) {
      let num = Math.floor(time / 3600)
      return num < 10 ? '0' + num : num
    }
    if (type === 2) {
      let num = Math.floor(time / 60 % 60)
      return num < 10 ? '0' + num : num
    }
    if (type === 3) {
      let num = Math.floor(time % 60)
      return num < 10 ? '0' + num : num
    }
  },
  channelType2: [
    {
      id: 'Minisite',
      name: '微网站渠道'
    },
    {
      id: 'Message',
      name: '微信公众号渠道'
    },
    {
      id: 'ThirdPartyChannel',
      name: '第三方应用渠道'
    }
  ],
  channelCategory: [
    {
      id: '',
      name: '全部类别'
    },
    {
      id: 'Subscribe',
      name: '订阅号'
    },
    {
      id: 'Service',
      name: '服务号'
    },
    {
      id: 'Enterprise',
      name: '企业号'
    }
  ],
  // 全局跳转
  toUrl (name, query) {
    console.log(Router)
    Router.push({
      name: name,
      query: query || {}
    })
  },
  // 全局返回
  backURL () {
    Router.history.go(-1)
  },
  confirmBack (content) {
    this.doubleComfirm({
      content: content,
      successFun: msg => {
        Router.history.go(-1)
      },
      errorFun: msg => {
      }
    })
  },
  alertTips (object) {
    let DOM = document.createElement('div')
    if (object.type === 'success') {
      DOM.className = 'allTips success'
    } else {
      DOM.className = 'allTips error'
    }
    // let html = `<span>${object.title}</span>: <span>${object.content}</span>`
    let html = `<span style="font-size: 16px">${object.content}</span>`
    let ramdanId = Math.floor(Math.random() * 9999)
    if (object.needDel) {
      html += '<i id="' + ramdanId + '" class="close">+</i>'
    }
    DOM.innerHTML = html
    document.body.appendChild(DOM)
    // setTimeout(() => {
    //   DOM.style.top = '40px'
    // }, 10)
    // DOM.style.right = '45%'
    let tips = document.querySelectorAll('.allTips')
    if (tips.length === 1) {
      setTimeout(() => {
        DOM.style.top = '40px'
      }, 10)
      DOM.style.right = '45%'
    } else {
      setTimeout(() => {
        DOM.style.top = parseInt(tips[tips.length - 2].style.top.replace('px', ''), 0) + (tips[tips.length - 2].clientHeight + 12) + 'px'
      }, 10)
      DOM.style.right = '45%'
    }
    if (object.needDel) {
      document.getElementById(ramdanId).onclick = p => {
        DOM.style.top = '-10%'
        setTimeout(() => {
          document.body.removeChild(DOM)
        }, 500)
      }
    }
    setTimeout(() => {
      DOM.style.right = '45%'
      setTimeout(() => {
        DOM.style.top = '-10%'
        setTimeout(() => {
          document.body.removeChild(DOM)
        }, 500)
      }, object.stayTime * 1000)
    }, 10)
  },
  alertNewTips (object) {
    let DOM = document.createElement('div')
    DOM.className = 'tobuDiv'
    // let html = `<span>${object.title}</span>: <span>${object.content}</span>`
    let html = `<div style="width: ${object.width}">
        <p class="m_b_10">
          <i class="icon iconfont icondui1"></i>
          <span>${object.title}</span>
        </p>
        <p>${object.content}</p>
      </div>`
    DOM.innerHTML = html
    document.body.appendChild(DOM)
    setTimeout(() => {
      DOM.style.top = '10%'
      setTimeout(() => {
        DOM.style.top = '-10%'
        setTimeout(() => {
          document.body.removeChild(DOM)
        }, 500)
      }, object.stayTime * 1000)
    }, 10)
  },
  returnQuery (url, object) {
    if (object) {
      let html = ''
      for (let i in object) {
        html += '&' + i + '=' + encodeURIComponent(object[i])
      }
      html = html.substr(1, html.length - 1)
      return url + '?' + html
    }
  },
  returnImgUrl (resourceId, type) {
    return process.env.config.maindataBaseUrl + '/api/Resource/get/' + resourceId + '?isFromOwnerHost=' + type
  },
  uploadFile (file, filetype) {
    let postFile = new FormData()
    postFile.append('files', file)
    var p = new Promise((resolve, reject) => {
      axios.postFile('/api/Resource/Upload?filetype=' + filetype, postFile, 1).then(msg => {
        resolve(msg)
      })
    })
    return p
  },
  getPoChangedFieldsList (urlHtml) {
    if (urlHtml) {
      var p = new Promise((resolve, reject) => {
        axios.get('/api/OpenPO/PoChangedFields?' + urlHtml).then(msg => {
          resolve(msg.data)
        })
      })
      return p
    } else {
      return []
    }
  },
  upSupportFile (file, url, fileTitle) {
    let postFile = new FormData()
    postFile.append(fileTitle, file)
    var p = new Promise((resolve, reject) => {
      axios.post(url, postFile).then(msg => {
        resolve(msg)
      })
    })
    return p
  },
  upSupportFileTxt (file, url, fileTitle, num) {
    let postFile = new FormData()
    postFile.append(fileTitle, file)
    var p = new Promise((resolve, reject) => {
      axios.postFile(url, postFile, num).then(msg => {
        resolve(msg)
      })
    })
    return p
  },
  doubleComfirm (object) {
    let dom = document.createElement('div')
    let imgOne = require('../model02.png')
    let imgTwo = require('../model04.png')
    dom.id = 'doubleConfirm'
    let html = ''
    if (object.remark) {
      html = `<div class="newTips">
        <div class="cover"  style="opacity: 1"></div>
        <div id="newTipsBody2" class="newTipsBody">
          <ul>
            <li class="d_f" style="justify-content: space-between;align-items: center"><span style="display:inline-block;width: 95%" class="font20 f_w"></span><i id="cancelButtom2" class="icon iconfont iconguanbi colorYellowF36A20" style="font-size: 25px"></i></li>
            <li class="t_c font18" style="padding-bottom: 2%;"><img src="${object.showImg ? imgOne : imgTwo}"></li>
            <li class="t_c font18" style="padding-bottom: 2%;"><i class="icon iconfont iconwarning m_r_10" style="font-size: 25px;"></i><span class="colorGray7F7F7F">${object.content}</span></li>
            <li class="t_c font18" style="padding-bottom: 2%;"><span style="color: #848484">${object.remark}</span></li>
            <li class="t_c" style="padding-top: 4%">
              <button id="confirmButtom1" class="suerButton m_r_10 m_l_10" ><span class="font12">${window.localStorage.getItem('language') === 'en-US' ? 'Yes' : '确定'}</span></button>
              <button id="cancelButtom1" class="cancelButton m_l_10 m_r_10" ><span class="font12">${window.localStorage.getItem('language') === 'en-US' ? 'NO' : '取消'}</span></button>
            </li>
          </ul>
        </div>
      </div>`
    } else {
      html = `<div class="newTips">
        <div class="cover"  style="opacity: 1"></div>
        <div id="newTipsBody2" class="newTipsBody">
          <ul>
            <li class="d_f" style="justify-content: space-between;align-items: center"><span style="display:inline-block;width: 95%" class="font20 f_w"></span><i id="cancelButtom2" class="icon iconfont iconguanbi colorYellowF36A20" style="font-size: 25px"></i></li>
            <li class="t_c font18" style="padding-bottom: 2%;"><img src="${object.showImg ? imgOne : imgTwo}"></li>
            <li class="t_c font18"><i class="icon iconfont iconwarning m_r_10" style="font-size: 25px;color: #FA6909"></i><span class="colorGray7F7F7F">${object.content}</span></li>
            <li class="t_c" style="padding-top: 4%">
              <button id="confirmButtom1" class="suerButton m_r_10 m_l_10" ><span class="font12">${window.localStorage.getItem('language') === 'en-US' ? 'Yes' : '确定'}</span></button>
              <button id="cancelButtom1" class="cancelButton m_l_10 m_r_10" ><span class="font12">${window.localStorage.getItem('language') === 'en-US' ? 'NO' : '取消'}</span></button>
            </li>
          </ul>
        </div>
      </div>`
    }
    dom.innerHTML = html
    document.body.appendChild(dom)
    setTimeout(function () {
      document.getElementById('newTipsBody2').style.opacity = '1'
      document.getElementById('newTipsBody2').style.top = '-30px'
    }, 10)
    let confirmButtom1 = document.getElementById('confirmButtom1')
    if (confirmButtom1) {
      confirmButtom1.onclick = function (e) {
        object.successFun(e)
        document.getElementById('newTipsBody2').style.opacity = '0'
        document.getElementById('newTipsBody2').style.top = '-100px'
        setTimeout(function () {
          document.body.removeChild(document.getElementById('doubleConfirm'))
        }, 300)
      }
    }
    let cancelButtom1 = document.getElementById('cancelButtom1')
    if (cancelButtom1) {
      cancelButtom1.onclick = function (e) {
        object.errorFun(e)
        document.getElementById('newTipsBody2').style.opacity = '0'
        document.getElementById('newTipsBody2').style.top = '-100px'
        setTimeout(function () {
          document.body.removeChild(document.getElementById('doubleConfirm'))
        }, 300)
      }
    }
    let cancelButtom2 = document.getElementById('cancelButtom2')
    if (cancelButtom2) {
      cancelButtom2.onclick = function (e) {
        object.errorFun(e)
        document.getElementById('newTipsBody2').style.opacity = '0'
        document.getElementById('newTipsBody2').style.top = '-100px'
        setTimeout(function () {
          document.body.removeChild(document.getElementById('doubleConfirm'))
        }, 300)
      }
    }
  },
  doubleComfirmFile (object) {
    let dom = document.createElement('div')
    let img = require('../model01.png')
    dom.id = 'doubleConfirm'
    let html = ''
    if (object.remark) {
      html = `<div class="newTips">
        <div class="cover"  style="opacity: 1"></div>
        <div id="newTipsBody2" class="newTipsBody">
          <ul>
            <li class="d_f" style="justify-content: space-between;align-items: center"><span style="display:inline-block;width: 95%" class="font20 f_w"></span><i id="cancelButtom2" class="icon iconfont iconguanbi" style="font-size: 25px"></i></li>
            <li class="t_c font18" style="padding-bottom: 2%;"><img src="${img}"></li>
            <li class="t_c font18" style="padding-bottom: 6%;"><i class="icon iconfont iconwarning m_r_10" style="font-size: 25px;color: #FA6909"></i><span class="colorGray7F7F7F">${object.content}</span></li>
            <li class="t_c font12" style="padding-bottom: 8%;"><span class="colorBlue4884E8">${object.remark}</span></li>
            <li class="t_c">
              <button id="confirmButtom1" class="suerButton m_r_10 m_l_10" ><span class="font12">${window.localStorage.getItem('language') === 'en-US' ? 'Yes' : '确定'}</span></button>
              <button id="cancelButtom1" class="cancelButton m_l_10 m_r_10" ><span class="font12">${window.localStorage.getItem('language') === 'en-US' ? 'NO' : '取消'}</span></button>
            </li>
          </ul>
        </div>
      </div>`
    } else {
      html = `<div class="newTips">
        <div class="cover"  style="opacity: 1"></div>
        <div id="newTipsBody2" class="newTipsBody">
          <ul>
            <li class="d_f" style="justify-content: space-between;align-items: center"><span style="display:inline-block;width: 95%" class="font20 f_w"></span><i id="cancelButtom2" class="icon iconfont iconguanbi colorYellowF36A20" style="font-size: 25px"></i></li>
            <li class="t_c font18" style="padding-bottom: 2%;"><img src="${img}"></li>
            <li class="t_c font18" style="padding-bottom: 6%;"><i class="icon iconfont iconwarning m_r_10" style="font-size: 25px;color: #FA6909"></i><span class="colorGray7F7F7F">${object.content}</span></li>
            <li class="t_c">
              <button id="confirmButtom1" class="suerButton m_r_10 m_l_10" ><span class="font12">${window.localStorage.getItem('language') === 'en-US' ? 'Yes' : '确定'}</span></button>
              <button id="cancelButtom1" class="cancelButton m_l_10 m_r_10" ><span class="font12">${window.localStorage.getItem('language') === 'en-US' ? 'NO' : '取消'}</span></button>
            </li>
          </ul>
        </div>
      </div>`
    }
    dom.innerHTML = html
    document.body.appendChild(dom)
    setTimeout(function () {
      document.getElementById('newTipsBody2').style.opacity = '1'
      document.getElementById('newTipsBody2').style.top = '-30px'
    }, 10)
    let confirmButtom1 = document.getElementById('confirmButtom1')
    if (confirmButtom1) {
      confirmButtom1.onclick = function (e) {
        object.successFun(e)
        document.getElementById('newTipsBody2').style.opacity = '0'
        document.getElementById('newTipsBody2').style.top = '-100px'
        setTimeout(function () {
          document.body.removeChild(document.getElementById('doubleConfirm'))
        }, 300)
      }
    }
    let cancelButtom1 = document.getElementById('cancelButtom1')
    if (cancelButtom1) {
      cancelButtom1.onclick = function (e) {
        object.errorFun(e)
        document.getElementById('newTipsBody2').style.opacity = '0'
        document.getElementById('newTipsBody2').style.top = '-100px'
        setTimeout(function () {
          document.body.removeChild(document.getElementById('doubleConfirm'))
        }, 300)
      }
    }
    let cancelButtom2 = document.getElementById('cancelButtom2')
    if (cancelButtom2) {
      cancelButtom2.onclick = function (e) {
        object.errorFunTwo(e)
        document.getElementById('newTipsBody2').style.opacity = '0'
        document.getElementById('newTipsBody2').style.top = '-100px'
        setTimeout(function () {
          document.body.removeChild(document.getElementById('doubleConfirm'))
        }, 300)
      }
    }
  },
  // 性别
  returnGender (type) {
    switch (type) {
      case 'Female':
        return window.localStorage.getItem('language') === 'en-US' ? 'Female' : '女'
      case 'Male':
        return window.localStorage.getItem('language') === 'en-US' ? 'Male' : '男'
      case '':
        return '-'
    }
    return ''
  },
  // 时间格式
  returnDate (date, type) {
    if (date === null || date === '' || date === undefined) {
      return ''
    } else {
      let newDate = new Date(date.replace(/-/g, '/'))
      let year = newDate.getFullYear()
      let month = newDate.getMonth() + 1
      let Todate = newDate.getDate()
      let hour = newDate.getHours()
      let min = newDate.getMinutes()
      let sec = newDate.getSeconds()
      // let zhYear = window.localStorage.getItem('language') === 'en-US' ? '/' : '年'
      // let zhMouth = window.localStorage.getItem('language') === 'en-US' ? '/' : '月'
      // let zhDate = window.localStorage.getItem('language') === 'en-US' ? ' ' : '日'
      month = month < 10 ? '0' + month : month
      Todate = Todate < 10 ? '0' + Todate : Todate
      hour = hour < 10 ? '0' + hour : hour
      min = min < 10 ? '0' + min : min
      sec = sec < 10 ? '0' + sec : sec
      if (type === 'YYMMDDHHMMSS') {
        return year + '/' + month + '/' + Todate + ' ' + hour + ':' + min + ':' + sec
      } else if (type === 'YYMMDD') {
        return year + '/' + month + '/' + Todate
      } else if (type === 'YYMMDDH') {
        return year + '-' + month + '-' + Todate
      } else if (type === 'YYMMDDHHMM') {
        return year + '/' + month + '/' + Todate + ' ' + hour + ':' + min
      } else if (type === 'YYMMDDZH') {
        return year + '年' + month + '月' + Todate + '日'
      } else if (type === 'HHMMSS') {
        return hour + ':' + min
      } else if (type === 'YY') {
        return year
      } else if (type === 'MM') {
        return month
      } else if (type === 'newYYMMDDSSFF') {
        return year + month + Todate + hour + min
      } else if (type === 'HH') {
        return hour
      } else if (type === 'MM') {
        return min
      }
    }
  },
  returnNewDate (date, type) {
    if (date === null || date === '' || date === undefined) {
      return ''
    } else {
      if (type === 'YYMMDD') {
        return date.split(' ')[0]
      } else {
        return date.split('.')[0].replace('T', ' ')
      }
    }
  },
  todayDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
  todayEndDate: (new Date().getFullYear() + 1) + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
  todayDateTime: (new Date().getFullYear()) + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' ' + (new Date().getHours() < 10 ? ('0' + new Date().getHours()) : new Date().getHours()) + ':' + (new Date().getMinutes() < 10 ? ('0' + new Date().getMinutes()) : new Date().getMinutes()) + ':' + (new Date().getSeconds() < 10 ? ('0' + new Date().getSeconds()) : new Date().getSeconds()),
  todayEndDateTime: (new Date().getFullYear() + 1) + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' ' + (new Date().getHours() < 10 ? ('0' + new Date().getHours()) : new Date().getHours()) + ':' + (new Date().getMinutes() < 10 ? ('0' + new Date().getMinutes()) : new Date().getMinutes()) + ':' + (new Date().getSeconds() < 10 ? ('0' + new Date().getSeconds()) : new Date().getSeconds()),
  todayTime: new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds(),
  lastDate: (new Date().getFullYear() + 2) + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
  checkIfEmpty (data, list, value) {
    let content = window.localStorage.getItem('language') === 'en-US' ? 'Please check the required fields' : '请检查必填项!'
    if (value) {
      content = value
    }
    for (let i in data) {
      if (list.indexOf(i) >= 0 && (data[i] === '' || data[i] === null)) {
        this.alertTips({
          type: 'error',
          title: '提示',
          content: content,
          stayTime: 5
        })
        return true
      }
    }
    return false
  },
  numFixed (num, fixedNum) {
    if (num !== null && num !== undefined) {
      let newFixedNum = fixedNum || 2
      if (fixedNum) {
        return (parseFloat(num).toFixed(newFixedNum) + '').replace(/\d{2,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
      } else {
        return (parseFloat(num).toFixed(newFixedNum) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
      }
    } else {
      return 0
    }
  },
  returnActivityHasOccurred (type) {
    if (type === true) {
      return 'Yes'
    } else if (type === false) {
      return 'No'
    } else {
      return type
    }
  },
  datafixBoolean (data, list) {
    for (let i in data) {
      if (list.indexOf(i) >= 0) {
        if (data[i] === 'true' || data[i] === true) {
          data[i] = true
        } else if (data[i] === 'false' || data[i] === false) {
          data[i] = false
        }
      }
    }
  },
  datafixNumber (data, list, fixedNum) {
    for (let i in data) {
      if (list.indexOf(i) >= 0) {
        if (fixedNum) {
          data[i] = data[i] ? parseFloat(parseFloat(data[i]).toFixed(2)) : 0
        } else {
          data[i] = data[i] ? parseInt(data[i]) : 0
        }
      }
    }
  },
  returnContentText (type, num) {
    if (num === 1) {
      switch (type) {
        case 'InRange30Days':
          return '小于等于30天有效期'
        case 'MoreThan30Days':
          return '大于30天有效期'
        case 'Expired':
          return '已过期'
      }
      return ''
    } else {
      switch (type) {
        case 'InRange30Days':
          return 'icon iconfont iconjinggao2 colorYellowF68C45'
        case 'MoreThan30Days':
          return 'icon iconfont iconyou1 colorGreen6FAF25'
        case 'Expired':
          return 'icon iconfont icongantan colorRedE84F59'
      }
      return ''
    }
  },
  // 隐藏手机号 隐藏身份证
  returnHide (type, num) {
    if (type) {
      if (num === 'phone') {
        let reg = /^(\d{3})\d{4}(\d{4})$/
        return type.replace(reg, '$1****$2')
      } else if (num === 'IdCard') {
        let reg = /^(\d{6})\d{8}(\d{4})$/
        return type.replace(reg, '$1********$2')
      } else if (num === 'email') {
        if (String(type).indexOf('@') > 0) {
          let str = type.split('@')
          let _s = ''
          if (str[0].length > 3) {
            for (var i = 0; i < str[0].length - 1; i++) {
              _s += '*'
            }
          }
          var newemail = str[0].substr(0, 1) + _s + '@' + str[1]
        }
        return newemail
      }
    }
  },
  fileAllow: ['png', 'jpg', 'jpeg', 'gif', 'bmp'],
  returnNewType (type, state) {
    if (state === 'gender') {
      switch (type) {
        case 'Male':
          return '男'
        case 'Female':
          return '女'
        case 'Unknow':
          return '未知'
        case 1:
          return '男'
        case 2:
          return '女'
        case 0:
          return '未知'
      }
      return ''
    } else if (state === 'tag') {
      switch (type) {
        case 'DynamicUserTag':
          return '动态标签'
        case 'StaticUserTag':
          return '静态标签'
        case 'CustomUserTag':
          return '自定义标签'
      }
      return ''
    }
  },
  returnDigit (type, name, content) {
    if (name === 'email') {
      let newEmal = /^[A-Za-z0-9]+([-_.][A-Za-z0-9]+)*@([A-Za-z0-9-_]+\.)+[A-Za-z]{2,6}$/
      if (!newEmal.test(type)) {
        this.alertTips({
          type: 'error',
          title: '错误',
          content: content,
          stayTime: 5
        })
        return true
      }
    } else if (name === 'number') {
      let freg = /^[1-9]\d*$/
      if (!freg.test(type)) {
        this.alertTips({
          type: 'error',
          title: '错误',
          content: content,
          stayTime: 5
        })
        return true
      }
    } else if (name === 'en') {
      let freg = /^[a-zA-Z]+$/
      if (!freg.test(type)) {
        this.alertTips({
          type: 'error',
          title: '错误',
          content: content,
          stayTime: 5
        })
        return true
      }
    }
    return false
  },
  // 压缩图片
  photoCompress (file, w, objDiv) {
    let ready = new FileReader()
    ready.readAsDataURL(file)
    ready.onload = function () {
      let re = this.result
      canvasDataURL(re, w, objDiv)
    }
  },
  // dataURLtoFile (dataurl) {
  //   let arr = dataurl.split(',')
  //   let mime = arr[0].match(/:(.*?);/)[1]
  //   let bstr = atob(arr[1])
  //   let n = bstr.length
  //   let u8arr = new Uint8Array(n)
  //   while (n--) {
  //     u8arr[n] = bstr.charCodeAt(n)
  //   }
  //   return new File([u8arr], { type: mime })
  // }
  getCookie (name) {
    var arr
    var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    arr = document.cookie.match(reg)
    if (arr) {
      return decodeURIComponent(arr[2])
    } else {
      return null
    }
  },
  // loading
  coverGif () {
    if (!document.getElementById('loadingGif')) {
      let dom = document.createElement('div')
      dom.id = 'loadingGif'
      let html = '<img src="' + avatar + '" height="144" width="192"/>'
      dom.innerHTML = html
      document.getElementById('app').appendChild(dom)
    }
  },
  disCover () {
    if (document.getElementById('loadingGif')) {
      document.getElementById('app').removeChild(document.getElementById('loadingGif'))
    }
  },
  returnHours (type) {
    if (parseInt(type) === 1) {
      let list = []
      for (let i = 0; i <= 24; i++) {
        let data = {
          id: i < 10 ? '0' + i : i,
          name: i < 10 ? '0' + i : i
        }
        list.push(data)
      }
      return list
    } else {
      let list = []
      for (let i = 0; i < 60; i++) {
        let data = {
          id: i < 10 ? '0' + i : i,
          name: i < 10 ? '0' + i : i
        }
        list.push(data)
      }
      return list
    }
  },
  // 获取浏览器类型
  getBrowser () {
    var userAgent = window.navigator.userAgent // 取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf('Opera') > -1 // 判断是否Opera浏览器
    var isIE = !!window.ActiveXObject || 'ActiveXObject' in window // 判断是否IE浏览器
    var isEdge = userAgent.indexOf('Edge') > -1 // 判断是否IE的Edge浏览器
    var isFF = userAgent.indexOf('Firefox') > -1 // 判断是否Firefox浏览器
    var isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1 // 判断是否Safari浏览器
    var isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1 // 判断Chrome浏览器
    if (isIE) {
      return 'IE'
    }
    if (isOpera) {
      return 'Opera'
    }
    if (isEdge) {
      return 'Edge'
    }
    if (isFF) {
      return 'Firefox'
    }
    if (isSafari) {
      return 'Safari'
    }
    if (isChrome) {
      return 'Chrome'
    }
  },
  // 数组对象去重 + 普通数组去重
  returnHeavy (item, key) {
    let returnArr = []
    if (key) {
      let newOb = {}
      returnArr = item.reduce((p, msg) => {
        // eslint-disable-next-line no-unused-expressions
        newOb[msg[key]] ? '' : newOb[msg[key]] = true && p.push(msg)
        return p
      }, [])
      return returnArr
    }
    returnArr = item.reduce((p, msg) => {
      !p.includes(msg) && p.push(msg)
      return p
    }, [])
    return returnArr
  },
  addLog (name, first, second, remark) {
    let logInfo = {
      operationName: name,
      firstLevelMenu: first,
      secondLevelMenu: second,
      remark: remark
    }
    var p = new Promise((resolve, reject) => {
      axios.post('/api/SystemLog/InsertOperationLog', logInfo).then(msg => {
        resolve(msg)
      })
    })
    return p
  },
  addDownloadLog (historyId, actionName, module) {
    let logInfo = {
      id: 0,
      historyId: historyId,
      actionName: actionName,
      module: module,
      remark: '',
      isSuccess: false
    }
    var p = new Promise((resolve, reject) => {
      axios.post('/api/SystemLog/InsertDownloadSyncLog', logInfo).then(msg => {
        resolve(msg)
      })
    })
    return p
  },
  updateDownloadLog (id, historyId, actionName, module, isSuccess) {
    let logInfo = {
      id: id,
      historyId: historyId,
      actionName: actionName,
      module: module,
      remark: '',
      isSuccess: isSuccess
    }
    var p = new Promise((resolve, reject) => {
      axios.post('/api/SystemLog/UpdateDownloadSyncLog', logInfo).then(msg => {
        resolve(msg)
      })
    })
    return p
  }
}
function canvasDataURL (path, obj, callback) {
  var img = new Image()
  img.src = path
  img.onload = function () {
    let that = this
    // 默认按比例压缩
    let w = that.width * 0.8
    let h = that.height * 0.8
    let scale = w / h
    w = obj.width || w
    h = obj.height || (w / scale)
    var quality = 0.7
    // 生成canvas
    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d')
    // 创建属性节点
    var anw = document.createAttribute('width')
    anw.nodeValue = w
    var anh = document.createAttribute('height')
    anh.nodeValue = h
    canvas.setAttributeNode(anw)
    canvas.setAttributeNode(anh)
    ctx.drawImage(that, 0, 0, w, h)
    // 图像质量
    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
      quality = obj.quality
    }
    // quality值越小，所绘制出的图像越模糊
    var base64 = canvas.toDataURL('image/jpeg', quality)
    let newFile = dataURLtoFile(base64)
    // 回调函数返回base64的值
    callback(newFile)
  }
}
// 将base64编码转回file文件
function dataURLtoFile (dataurl) {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], '1.jpg', { type: mime })
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js